import axios from "axios";

const GET_API_URL  = process.env.REACT_APP_CONFIGURL;
const SET_API_URL = process.env.REACT_APP_BASEURL;
const REACT_APP_LOGINURL = process.env.REACT_APP_LOGINURL;

  
const headers =  { 
  'Content-Type': 'application/json',
  'token': localStorage.getItem("session-id")
}
  
const getConfiguration = (sessionID) => {
  var payload = {
    functionName: "GetConfigurations",
    postData: {},
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(GET_API_URL, payload, {headers});
};

const setConfiguration = (sessionID,payload) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(SET_API_URL, payload, {headers});
};

const GetAutoCount = (sessionID) => {
  var payload = {
    functionName: "GetAutoCount",
    postData: {},
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(REACT_APP_LOGINURL+'autoCount', payload, {headers});
};

const SetAutoCount = (sessionID,payload) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(REACT_APP_LOGINURL+'autoCount', payload, {headers});
};

const ConfigurationService = {
  getConfiguration,
  GetAutoCount,
  SetAutoCount,
  setConfiguration
};
  
export default ConfigurationService;

